import React from 'react';
import Button from './Button';

export default function ButtonDanger({className, ...otherProps}) {
  return <Button className={`btn-danger ${className}`} {...otherProps}/>
}